import { API } from '../../utils/amplifyWrapper';
import { useMutation, useQueryClient } from "@tanstack/react-query";

interface IDeleteProfileRequestProps {
    org_id: string
    integration_id: string 
    id: string
}

export const useDeleteProfile = () => {
    const queryClient = useQueryClient();
    
    return useMutation(
        async ({ org_id, integration_id, id }: IDeleteProfileRequestProps) => {
            const response = await API.del(
                `main`, 
                `/organisation/${org_id}/integration/${integration_id}/audio_profile/${id}`, 
                { headers: { "Content-Type": "application/json" } }
            );
            return { response, org_id, integration_id };
        },
        {
            onSuccess: ({ org_id, integration_id }) => {
                // ✨ Invalidate queries at hook level
                queryClient.invalidateQueries(['audio_profile', org_id, integration_id]);
            }
        }
    )
}

